import React, { memo, useMemo } from 'react';

import Logo from '@/components/atomic/molecules/navigation/logo';
import type { LogoHandlerProps } from '@/components/atomic/molecules/navigation/logo-handler/typings';
import withExposer from '@/hocs/with-exposer';
import useActiveBrand from '@/hooks/use-active-brand';
import { BasicComponentProps } from '@/typings/generic';

const LogoHandlerComponent: React.FC<
	LogoHandlerProps & BasicComponentProps
> = ({ logos, $exposerSuffix }) => {
	const activeBrand = useActiveBrand();

	const activeBrandLogo = useMemo(
		() => logos?.find((logo) => logo.brand === activeBrand),
		[activeBrand, logos],
	);

	const fallbackLogo = useMemo(
		() => logos?.find((logo) => logo.fallbackLogo),
		[logos],
	);

	const selectedLogo = useMemo(
		() => activeBrandLogo || fallbackLogo,
		[activeBrandLogo, fallbackLogo],
	);

	if (!selectedLogo) return null;

	return <Logo {...selectedLogo} $exposerSuffix={$exposerSuffix} />;
};

const LogoHandler = memo(withExposer(LogoHandlerComponent, 'logoHandler'));

export default LogoHandler;
